import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const ClientDetailsPage = lazy(() => import('./ClientDetailsPage'));

const ClientDetailsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Sales,
  routes: [
    {
      path: 'clients/:id',
      element: <ClientDetailsPage />,
    },
  ],
};

export default ClientDetailsConfig;
